import { Component, output, ChangeDetectionStrategy, effect } from '@angular/core';
import { AbstractDynamicReportViewComponent } from '../../abstract/abstract-dynamic-report-view.component';
import { DataObject, ReportRecord } from '../../models/report.model';
import { CdkDragDrop, CdkDropList, CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { onDrop } from './summary-view.helper';
import { InterpolatedBlueprint } from '../../models/blueprint.model';
import { TemplateField } from '../../models/template.model';
import { PROPERTY_MAP_ADDRESS } from './summary-view.model';
import { groupByProperty } from '../../shared/utils/group-by-property';
import { ActionsToolbarComponent } from '../presentation-view/actions-toolbar/actions-toolbar.component';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

import { ReportFieldFormatterPipe } from '../../shared/pipes/report-field-formatter.pipe';
import { SelectTemplateOutletPipe } from '../../shared/pipes/select-template-outlet.pipe';
import { ReportRecordRouteFnPipe } from '../../shared/pipes/report-record-route-fn.pipe';
import { IsFieldVisiblePipe } from '../../shared/pipes/field-visible.pipe';
import { L10nTranslatePipe } from 'angular-l10n';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'rep-summary-view',
  templateUrl: './summary-view.component.html',
  styleUrl: './summary-view.component.scss',
  imports: [
    ActionsToolbarComponent,
    NgTemplateOutlet,
    CdkDropList,
    CdkDrag,
    MatIcon,
    CdkDragHandle,
    AsyncPipe,
    ReportFieldFormatterPipe,
    SelectTemplateOutletPipe,
    ReportRecordRouteFnPipe,
    IsFieldVisiblePipe,
    L10nTranslatePipe
],
})
export class SummaryViewComponent extends AbstractDynamicReportViewComponent {
  readonly removeRecord = output<ReportRecord>();
  readonly reportReordered = output<any>();
  summaryAddressPaths: DataObject;
  summaryRecords: ReportRecord[] = [];

  bodyFields: TemplateField[];

  constructor() {
    super();
    effect(() => {
      const reportOptions = this.reportOptions();
      const reportData = this.reportData();
      if (reportOptions && reportData) {
        if (reportOptions.groupByBuilding) {
          this.summaryRecords = groupByProperty(reportData.records) as ReportRecord[];
          this.summaryRecords.forEach((record, index) => {
            record.position = index + 1;
          });
        } else {
          this.summaryRecords = reportData.records;
        }
        this.getAddressMaps();
      }
    });
  }

  protected prepareGroupsObjectToDisplay(interpolatedBlueprint: InterpolatedBlueprint) {
    super.prepareGroupsObjectToDisplay(interpolatedBlueprint);
    if (this.bodyGroups.length) {
      this.bodyFields = [].concat(...(this.bodyGroups || []).map(group => group.fields));
    }
  }

  removeRecordFromReport(reportItem: ReportRecord, recordIndex: number) {
    const recordId = reportItem.recordId ? reportItem.recordId : reportItem.data[recordIndex].recordId;
    this.removeRecord.emit({ ...reportItem, recordId });
  }
  onReorder(cdkDragDropEvent: CdkDragDrop<Array<{ [key: string]: any }>>) {
    onDrop(cdkDragDropEvent, this.reportData().records, this.reportReordered);
  }

  private getAddressMaps() {
    const reportData = this.reportData();
    this.summaryAddressPaths = {
      postalAddress: reportData.entity
        ? PROPERTY_MAP_ADDRESS[reportData.entity]
        : PROPERTY_MAP_ADDRESS.property,
    };
  }
}
